import { useState } from "react";
import Layout from "./Layout";
import MapView from "./MapView";
import SettingsSheet from "./SettingsSheet";

export default function Home({ user }) {
    const [settingsOpen, setSettingsOpen] = useState(false);
    return (
        <Layout user={user} onOpenSettings={() => setSettingsOpen(true)}>
            <MapView user={user} />
            <SettingsSheet open={settingsOpen} onClose={() => setSettingsOpen(false)} user={user} />
        </Layout>
    );
}
